import { Step } from 'react-joyride';

export const dashboardWalkthroughSteps: Step[] = [
  {
    target: '.walkthrough-compare-performance',
    content:
      "By clicking here you're able to add your company's data, then overlay it with Compass software benchmarks.",
    disableBeacon: true,
    disableScrolling: true
  },
  {
    target: '.walkthrough-tabs-list',
    content:
      'Easily expand and navigate through different charts from the left side panel.',
    disableBeacon: true,
    placement: 'right-start'
  },
  {
    target: '.walkthrough-filters',
    content:
      'Explore the data from different software sectors, growth motions, and primary customer segments.',
    disableBeacon: true,
    disableScrolling: true
  },
  {
    target: '.walkthrough-switch',
    content:
      'Switch seamlessly between Top Quartile and Median performance comparisons.',
    disableBeacon: true
  },
  {
    target: '.walkthrough-switch-2',
    content:
      'Switch seamlessly between Last 4 years and All time performance comparisons. ',
    disableBeacon: true
  },
  {
    target: '.walkthrough-shareable-url',
    content:
      'Share your benchmarks! Click this button to copy a shareable URL to your clipboard.',
    disableBeacon: true,
    placement: 'left'
  },
  {
    target: '.walkthrough-resources',
    content:
      'Find articles on related trends, relevant insights, and key information.',
    disableBeacon: true
  },
  {
    target: '.walkthrough-chatbot-button',
    content:
      'Ask Compass and get instant insights and answers about your business growth metrics and performance data.',
    disableBeacon: true,
    disableScrolling: true
  }
];

export const dataModalWalkthroughSteps: Step[] = [
  {
    target: '.walkthrough-required-info',
    content:
      "This data is required to overlay your company's data onto Compass software benchmarks.",
    disableBeacon: true,
    disableScrolling: true,
    placement: 'right'
  },
  {
    target: '.walkthrough-optional-info',
    content:
      'This data is optional, but adding it will allow you to see this data overlaid onto Compass software benchmarks.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'right'
  },
  {
    target: '.walkthrough-calculate',
    content:
      "Enter your data manually, or click 'Calculate' to open a form for guidance.",
    disableBeacon: true,
    disableScrolling: true,
    placement: 'bottom'
  },
  {
    target: '.walkthrough-email',
    content: 'Submit your information by inputting your email address.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'top'
  }
];

export const dataModalWalkthroughStepsNonPortco: Step[] = [
  ...dataModalWalkthroughSteps,
  {
    target: '.walkthrough-saved-user-data',
    content:
      'Select any data set from this saved user data section to see it overlaid onto Compass software benchmarks.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'top'
  }
];

const firstPortcoWalkthroughStep: Step = {
  target: '.key-financials',
  content: 'Edit your company financials with updated data.',
  disableBeacon: true,
  disableScrolling: true,
  placement: 'right'
};

export const nonReviewedPortCoWalkthroughSteps: Step[] = [
  firstPortcoWalkthroughStep,
  {
    target: '.walkthrough-confirm',
    content: 'Confirm the updated financial information.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'left'
  }
];

export const reviewedPortCoWalkthroughSteps: Step[] = [
  firstPortcoWalkthroughStep,
  {
    target: '.walkthrough-update-data',
    content: 'Submit the updated company financials by clicking this button.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'left'
  },
  {
    target: '.walkthrough-history-data',
    content:
      'you can select any previous edits done by you to view old company data.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'left'
  }
];
